import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import PortalVue from "portal-vue";
import lodash from "lodash";
import VueAnalytics from "vue-analytics";
import Meta from "vue-meta";
import VueMobileDetection from "vue-mobile-detection";

Vue.use(VueMobileDetection);
Vue.use(Meta);

Vue.use(VueAnalytics, {
  id: "UA-35011185-2",
  router,
  debug: {
    sendHitTask: process.env.NODE_ENV === "production"
  }
});

Vue.config.productionTip = false;
Vue.use(PortalVue);

window._ = lodash;
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
